"use strict";
/*
 * Created on 10 05 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Jaroslav Sevcik
 */


var CompetitorReferentialPriceConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(CompetitorReferentialPriceConverter, _DataObjectConverter_);

  function CompetitorReferentialPriceConverter() {
    _classCallCheck(this, CompetitorReferentialPriceConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompetitorReferentialPriceConverter).apply(this, arguments));
  }

  return CompetitorReferentialPriceConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.CompetitorReferentialPriceConverter = CompetitorReferentialPriceConverter;